import { Controller } from '@hotwired/stimulus';

export const create = () => {
	return class extends Controller {
		static targets = ['video'];
		connect() {
			const video = this.videoTarget;

			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				video.removeAttribute('autoplay');
				video.pause();

				if (video.paused) {
					this.element.classList.add('is-paused');
					this.element.classList.remove('is-playing');
				} else {
					this.element.classList.remove('is-paused');
					this.element.classList.add('is-playing');
				}
			} else {
				video.setAttribute('autoplay', 'true');
				video.play();
				this.element.classList.add('is-autoplay');
				this.element.classList.remove('is-paused');
				this.element.classList.add('is-playing');
			}
		}
		play() {
			this.videoTarget.play();
			this.element.classList.remove('is-paused');
			this.element.classList.add('is-playing');
		}
		pause() {
			this.videoTarget.pause();
			this.element.classList.add('is-paused');
			this.element.classList.remove('is-playing');
		}
	};
};
